export default __webpack_public_path__ + "static/media/flag-en-US.586af633.png";